// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"91766e34","223":"7b1ac2b4","270":"3be4263d","347":"3c8d1eb7","422":"28123d2c","463":"f0a577d8","787":"170f422e","933":"dd521686"}[chunkId] + ".chunk.js";
};